import { postComplaint } from './complaints'
import { postEnergyCrisisFixProductCase } from './energyCrisisFixProduct'

export default {
  postComplaint,
  postEnergyCrisisFixProductCase
}
